import gql from 'graphql-tag'

export const TOKEN = gql`
  mutation registerPushNotificationToken($token: String!) {
    registerPushNotificationToken(token: $token)
  }
`
